import { post } from '../request';
import { APP_CONFIG } from '../../config';
import { ITenantProtectionStarted } from '../../@types/tenantProtection';

export const startTenantProtection = async () => {
  return await post<ITenantProtectionStarted, any>(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/tenant-protection/start`,
    undefined,
    'XSRF-TOKEN',
  );
};

export const validateToken = async (token: string) => {
  return await post<boolean, any>(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/tenant-protection/validate-token`,
    { token },
    'XSRF-TOKEN',
  );
};
